<template>
  <div class="fabric-container">
    <div class="d-flex align-items-center">
      <span style="font-size: 15px;font-weight: 600; color: #2B3447">
        {{
          amzSkuMaterialGroup === 'packaging'
            ? $l('INDEX.amz_sku_tab_pane_label_packaging') || '包装辅料'
            : $l('INDEX.amz_sku_tab_pane_label_sewing') || '缝制辅料'
        }}
      </span>
      <el-divider direction="vertical" v-if="!disabledEdit"></el-divider>
      <div v-if="!disabledEdit">
        <el-button size="mini" class="ml-2" @click="addMaterial">{{
          $l('INDEX.amz_sku_label_add_materials') || '添加辅料'
        }}</el-button>
      </div>
    </div>
    <div class="fabric-list-info__container">
      <div v-for="item in specList" :key="item.amzSkuMaterialCode">
        <MaterialInfo
          :ref="'fabricSpecRef-' + item.amzSkuMaterialCode"
          :amzSkuCode="amzSkuCode"
          :materialInfo="item"
          :disabled="disabled"
          :isFormal="isFormal"
          @delMaterial="delMaterial"
          @editMaterial="editMaterial"
          @openArtWork="openArtWork"
        ></MaterialInfo>
      </div>
      <div v-if="isEmpty" class="no-data__wrapper">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
    <MaterialSetting
      v-if="fabricBatchVisible"
      :visible.sync="fabricBatchVisible"
      :disabled="disabledEdit"
      @close="closeFabricBatchSetting"
      @reload="initSpec"
      :amzSkuCode="amzSkuCode"
      :amzSkuMaterialGroup="amzSkuMaterialGroup"
      :amzSkuMaterialCode.sync="amzSkuMaterialCode"
    ></MaterialSetting>
    <ArtworkDrawer
      v-if="artworkVisible"
      :visible.sync="artworkVisible"
      @close="close"
      :amzSkuCode="amzSkuCode"
      :amzSkuMaterialCode.sync="amzSkuMaterialCode"
    ></ArtworkDrawer>
  </div>
</template>
<script>
import MaterialInfo from './material-info'
import MaterialSetting from './material-setting'
import ArtworkDrawer from './artwork/ArtworkDrawer.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { MaterialInfo, MaterialSetting, ArtworkDrawer },
  props: {
    disabled: { type: Boolean, default: true },
    isFormal: { type: Boolean, default: false },
    amzSkuCode: { type: String, default: '' },
    amzSkuMaterialGroup: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {
      specList: [],
      checkSpecList: [],
      fabricBatchVisible: false,
      artworkVisible: false,
      amzSkuMaterialCode: '',
      currentOpenIndex: null,
    }
  },
  computed: {
    disabledEdit() {
      return this.disabled || this.isFormal
    },
    isEmpty() {
      return !this.specList.length
    },
  },
  mounted() {
    this.initSpec()
  },
  methods: {
    initSpec() {
      if (!this.amzSkuCode) return
      this.$api
        .ecomAmzSkuMaterialListApi({
          amzSkuCode: this.amzSkuCode,
          amzSkuMaterialGroup: this.amzSkuMaterialGroup,
        })
        .then((res) => {
          this.specList = []
          this.specList = res.body.data
        })
    },
    delMaterial(e) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .ecomAmzSkuMaterialDelApi({
            amzSkuMaterialCode: e.amzSkuMaterialCode,
          })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.initSpec()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    editMaterial(e) {
      this.fabricBatchVisible = true
      this.amzSkuMaterialCode = e.amzSkuMaterialCode
    },
    addMaterial() {
      this.fabricBatchVisible = true
      this.amzSkuMaterialCode = ''
    },
    openArtWork(e) {
      this.artworkVisible = true
      this.amzSkuMaterialCode = e.amzSkuMaterialCode
    },

    closeFabricBatchSetting() {
      this.fabricBatchVisible = false
    },
    close() {
      this.$refs[
        `fabricSpecRef-${this.amzSkuMaterialCode}`
      ]?.[0]?.reloadArtwork()
    },
  },
}
</script>
<style lang="scss" scoped>
.no-data__wrapper {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fabric-list-info__container {
  margin-top: 10px;
}
</style>
